import { VmsService } from 'src/app/services/vms.service';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { ExcelDataProvider } from 'src/app/providers/excel.provider';
import { DateService } from 'src/app/services/date.service';


@Component({
  standalone: false,
  selector: 'app-bulk-invite-preview',
  templateUrl: './bulk-invite-preview.component.html',
  styleUrls: ['./bulk-invite-preview.component.scss'],
})
export class BulkInvitePreviewComponent implements OnInit {
  name: boolean;
  fieldErrors: any[];
  mobile: any;
  email: any;
  guestName: any;
  guestMobile: boolean;
  guestEmail: any;
  vehicleNumber: any;
  vehicleType: any;
  floor: any;
  buildingName: any;
  formatDate: string;
  buildingTitle: string = '';
  amorpm: boolean = false;
  amorpm1: boolean = false;
  normalizeTime: any;
  remarks: string = '';
  startTimePlaceholder: string = '';
  endTimePlaceholder: string = '';
  buildingProperty: any = [];
  floorProperty: any = [];
  floorTitle: any;
  tableHeaders: any[] = [];
  tableBody: any = [];
  selectAll: boolean = false;
  popover: any = null;
  meridian: boolean = true;
  startTime = { hour: 1, minute: 0 };
  endTime = { hour: 1, minute: 0 };
  data: any;
  fullname: string;
  mobileNumber: any;
  emailId: string;
  myCompanyData: any;
  buildingId: any;
  guestList: any;
  floorCount: any;
  floorList: any;
  vehicleTypeList: any;
  meetingPurposeData: any;
  tempMeetingPurposeData: any;
  meetingPurpose: any;
  t0600Vmsguests: any = [];
  mdate: any;
  selectedDate: any;
  userId: any;
  mend: any;
  tempTime: any;
  tempEndTime: any;
  id: any;
  tempGuestList: any = [];
  showError: boolean;
  errName: any;
  errfloor: any;
  constructor(
    private router: Router,
    private dateSrv: DateService,
    public datepipe: DatePipe,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute,
    private VmsService: VmsService
  ) {
    const current = new Date();
    ngbDatepickerConfig.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };
    //ngbDatepickerConfig.maxDate = { year: 2099, month: 12, day: 31 };
    ngbDatepickerConfig.outsideDays = 'hidden';
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(res => {
      this.id = res.id ? res.id : null
    })
    this.getVehicleType();
    this.getMeetingPurpose();
    if (this.id !== null) this.loadData(this.id);
    else this.getMyCompanyDetails('645');

    this.data = this.VmsService.getExcelData();
    if (this.data != null) {
      this.prepareTableData(JSON.parse(this.data));
    }

    const jsDate = new Date();
  }

  loadData(id) {
    const data = {
      InvitationID: id,
    };

    this.VmsService.getInvitationDetail(data).subscribe((res) => {
      console.log(res);
      for (let i = 0; i < res?.t0600Vmsguests.length; i++) {
        const tempGuestList = {
          "Sr.No.": i + 1,
          "Guest name": res?.t0600Vmsguests[i].fullName,
          "Email ID": res?.t0600Vmsguests[i].email,
          "Contact No.": res?.t0600Vmsguests[i].mobile,
        }
        this.tempGuestList.push(tempGuestList)
      }
      this.prepareTableData(this.tempGuestList)
      this.getMyCompanyDetails(res?.parkUserId)
      this.setBuildingName(res?.buildingId)
      this.setFloor(res?.floor)

    })
      ;
  }

  public updateSelectedDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    // this.selectedDate = this.datepipe.transform(jsDate, 'yyyy-MM-dd');
    this.selectedDate = this.convertFormat(date.year, date.month, date.day);
    this.formatDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    this.formatDate = this.formatDate.split(' ')[0] + ' ' + this.formatDate.split(' ')[1] + ', ' + this.formatDate.split(' ')[2];
  }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    this.popover = popover
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }



  enterName(field) {
    if (field == 'name') {
      this.name = !this.name;

    }
    if (field == 'mobile') {
      this.mobile = !this.mobile;

    }
    if (field == 'email') {
      this.email = !this.email;
    }
    if (field == 'guestName') {
      this.guestName = !this.guestName;
    }
    if (field == 'guestMobile') {
      this.guestMobile = !this.guestMobile;
    }
    if (field == 'guestEmail') {
      this.guestEmail = !this.guestEmail;
    }
    if (field == 'vehicleNumber') {
      this.vehicleNumber = !this.vehicleNumber;
    }
    if (field == 'vehicleType') {
      this.vehicleType = !this.vehicleType;
    }
    if (field == 'floor') {
      this.floor = !this.floor;
    }
    if (field == 'buildingName') {
      this.buildingName = !this.buildingName;
    }
  }



  bulkInvite(data) {
    var files = data.target.files; // FileList object
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json.parseExcel(files[0]).then(data => {
      this.prepareTableData(JSON.parse(data));
    }).catch(err => {
      console.log('Failed to read excel ', err)
    });
  }

  prepareTableData(tableData) {
    console.log(tableData)
    this.tableBody = [];
    this.tableHeaders = [];
    // this.tableBody = tableData
    let sampleheaders = [];
    for (let header of tableData)
      sampleheaders.push(...Object.keys(header));
    this.tableHeaders = [...new Set(sampleheaders)];
    for (let body of tableData) {
      let temp = [];
      for (let head of this.tableHeaders) {
        temp.push(body[head] == undefined ? '' : body[head])
      }
      this.tableBody.push(temp)
      this.guestList = this.tableBody
      console.log(this.guestList)
    }
  }

  selectAllHandler() {
    if (this.selectAll) { }
  }

  selectedGuest(guestData, index) {
    console.log(guestData, index)
  }
  deleteAllInvites() {
    if (this.selectAll) {
      this.tableBody = [];
      this.tableHeaders = [];
    }
  }

  generateUniqueId(i, type) {
    return i + '__' + type;
  }

  checkIfSelected(id: string) {
    const ele = document.getElementById(id) as HTMLInputElement;
    return !ele.checked ? 'disabledClick' : ''
  }

  deleteSelected(inviteData, i) {
    if (this.checkIfSelected(i + '__th') !== 'disabledClick')
      this.tableBody.splice(i, 1)
  }

  toggleAmPmSelection(value: boolean) {
    console.log(value)
    this.amorpm = value;
    this.onTimeChange(this.tempTime);
  }

  toggleAmPmSelection1(value: boolean) {
    this.amorpm1 = value
    this.onTimeChange1(this.tempEndTime);
  }

  toggleMeridian() {
    this.meridian = !this.meridian;
  }


  onTimeChange(e) {
    this.tempTime = e;
    console.log(e, this.amorpm);
    // if (e.hour >= 0 && e.hour <= 11) this.amorpm = false;
    // else this.amorpm = true;
    this.startTimePlaceholder =
      ('0' + (e.hour > 12 ? e.hour - 12 : e.hour)).slice(-2) +
      ':' +
      ('0' + e.minute).slice(-2) +
      ' ' +
      (this.amorpm ? 'PM' : 'AM');
    console.log('time', this.startTimePlaceholder);
  }

  onTimeChange1(e) {
    this.tempEndTime = e;
    console.log(e);
    // if (e.hour >= 0 && e.hour <= 11)
    //   this.amorpm1 = false;
    // else
    //   this.amorpm1 = true;
    this.endTimePlaceholder = ('0' + (e.hour > 12 ? e.hour - 12 : e.hour)).slice(-2) + ':' + ('0' + e.minute).slice(-2) + ' ' + (this.amorpm1 ? 'PM' : 'AM');
  }



  editSelected(from, to, i, type) {
    if (this.checkIfSelected(i + '__th') !== 'disabledClick') {
      if (document.getElementById(i + '__edit').style.display == 'block') {
        document.getElementById(i + '__edit').style.display = 'none';
        document.getElementById(i + '__save').style.display = 'block'
      } else {
        document.getElementById(i + '__edit').style.display = 'block';
        document.getElementById(i + '__save').style.display = 'none'
      }
      let fromEle = document.getElementsByClassName(from);
      let toEle = document.getElementsByClassName(to);
      console.log(Object.keys(fromEle))
      for (let el of Object.keys(fromEle))
        if (document.getElementsByClassName(from)[el].style.display == 'block')
          document.getElementsByClassName(from)[el].style.display = 'none';
        else
          document.getElementsByClassName(from)[el].style.display = 'block';

      for (let el of Object.keys(toEle))
        if (document.getElementsByClassName(to)[el].style.display == 'block')
          document.getElementsByClassName(to)[el].style.display = 'none';
        else
          document.getElementsByClassName(to)[el].style.display = 'block';

      if (type == 'save') {
        let _t = [];
        for (let el of Object.keys(toEle)) {
          _t.push(document.getElementsByClassName(to)[el].value);
        }
        this.tableBody.splice(i, 1, _t);
      }
    }
  }

  getMyCompanyDetails(id) {
    const ParkId = localStorage.getItem('parkTenantId')
    this.VmsService
      .getMyCompanyDetails(ParkId)
      .subscribe((response: any) => {
        // if(response?.data!=null){
        this.myCompanyData = response?.data?.employees;

        this.data = this.myCompanyData.filter((el) => el.userId == id);
        console.log(this.data);
        // this.setFullName(this.data)
        this.fullname = this.data[0].name
        this.getHostDetail(this.data[0].userId);
        // }
      });
  }

  setFullName(item) {
    console.log("set full name", item)
    this.fullname = item.name;
    this.getHostDetail(item.userId);
  }

  setBuildingName(item) {
    this.buildingTitle = item.buildingName;
    this.buildingId = item.parkBuildingId;
  }

  setFloor(item) {
    this.floorTitle = item;
  }

  setVehicleType(item, i) {
    this.guestList[i].vehicleType = item.vehicleType;
  }

  getHostDetail(data) {
    this.floorList = [];
    this.userId = data;
    console.log("host detail", data)
    const param = {
      userId: data,
    };
    this.VmsService.getHostDetail(param).subscribe((res) => {
      console.log(res);
      this.mobileNumber = res.data ? res.data.mobile : res.mobile;
      this.emailId = res.data ? res.data.emailId : res.emailId;
      this.buildingProperty = res.data ? res.data.userBuilding : res.userBuilding;
      this.floorCount = res.data ? res.data.floors : res.floors;
      if (this.floorCount == 0 || this.floorCount == null) {
        this.floorList.push('1');
      }
      for (let i = 1; i < this.floorCount; i++) {
        this.floorList.push(i);
      }
    });
  }

  getVehicleType() {
    this.VmsService.getVehicleType().subscribe((res) => {
      console.log(res);
      this.vehicleTypeList = res;
    });
  }

  getMeetingPurpose() {
    this.VmsService.getMeetingPurpose().subscribe((res) => {
      this.meetingPurposeData = res;
      console.log(res);
      this.tempMeetingPurposeData = this.meetingPurposeData.filter(
        (el) => el.meetingPurpose.trim() == 'Official'
      );
      // console.log(this.meetingPurpose);
      this.meetingPurpose = this.tempMeetingPurposeData[0].meetingPurposeId;
    });
  }

  concatDateTime(type) {
    if (type == 'mstart') {
      return this.selectedDate.concat(
        ' ' + this.startTimePlaceholder
      );
    }
    else {
      return this.selectedDate.concat(
        ' ' + this.endTimePlaceholder
      );
    }
  }

  send(val) {
    this.validation(val);
    if (this.showError == true) {
      return;
    }

    this.t0600Vmsguests = [];
    this.mdate = this.concatDateTime('mstart');
    this.mend = this.concatDateTime('mend');

    for (let i = 0; i < this.guestList.length; i++) {
      const guestData =
      {
        fullName: this.guestList[i][1],
        mobile: this.guestList[i][3],
        email: this.guestList[i][2],
      }
      console.log(guestData)
      this.t0600Vmsguests.push(guestData);
    }

    const data = {
      // parkUserId: this.userId,
      mstart: this.mdate,
      mend: this.mend,
      // buildingId: this.buildingId,
      parkUserId: 645,
      // mstart: "2021-10-14T04:38:21.118Z",
      // mend: "2021-10-14T04:38:21.118Z",
      buildingId: "F815DE89-B92E-4443-ACEA-391820DADA32",
      floor: this.floorTitle,
      meetingPurpose: this.meetingPurpose,
      remarks: this.remarks,
      isActive: true,
      isApproved: true,
      t0600Vmsguests: this.t0600Vmsguests,
      invitationTypeName: 'bulkInvite',
      companyId: localStorage.getItem('tenantId')
    };
    console.log(data);
    this.VmsService.createInvitation(data).subscribe((res) => {
      console.log(res);
      this.router.navigate(['/vms/bulk-invite/invite'], { queryParams: { sucess: true } });

    });
  }


  validation(validate) {
    this.showError = false;
    this.errName = validate.form.controls.building?.status;
    console.log(this.errName);
    if (this.errName == 'INVALID')
      this.showError = true;
  }
}
